import { diInject } from 'stores/diContext';

import { SplashpageService } from '../services/splashpage';
import { observable, computed } from 'mobx';
import { PartType } from "consts/SplashPage";
import { EventService } from "Apps/ticketing/services/events";


export const SplashpageStatus={
    Loading: 'loading',
    Success: "success",
    Deactive:"deactive"
}

export const OtherEventsPartStatus = SplashpageStatus;

export class OtherEventsPartStore {
    @diInject() eventService: EventService;
    events = [];
    @observable status = OtherEventsPartStatus.Loading;

    constructor(public part) {
        this.loadEvents();
    }

    private async loadEvents() {
        var ids = this.part.events.map(e => e.event_id);
        var events = await this.eventService.getSummany(ids);
        this.events = events;
        this.status = OtherEventsPartStatus.Success;
    }
}


export class SplashpageStore {
    @diInject() splashpageService: SplashpageService;

    @observable selectedNav = "home";
    splashpage = null;
    @observable status = SplashpageStatus.Loading;
    //单独提出主题，避免在切换的时候闪一下
    @observable theme = null;   
    private partMaps = observable.map<any>();
    @computed get parts() {
        return this.partMaps.values();
    }

    setNav(nav_id){ 
        if(this.selectedNav!=nav_id){
            this.selectedNav=nav_id;
        }
    }

    clear() {
        this.theme = null;
        this.partMaps.clear();
    }

    setTheme(theme) {
        this.theme = theme;
    }

    async getSplashPage(event_id) {
        if (this.splashpage) {
            this.splashpage = null;
            this.partMaps.clear();
        }
        this.status = SplashpageStatus.Loading;
        var page = await this.splashpageService.get(event_id);
        if (page) {
            if (!page.is_active) {
                this.status = SplashpageStatus.Deactive;
                return;
            }
            let theme = page.theme;
            if (theme == "0") {
                theme = "dark";
            }
            if (theme == "1") {
                theme = "light";
            }
            this.theme = theme;

            this.splashpage = page;
            for (let part of page.parts) {
                let part_key = `${part.type}_${part.id}`;
                //#region 兼容代码
                var convert = {
                    [0]: "dark",
                    [1]: "light"
                }
                var background_color = convert[part.background_color]
                if (background_color) {
                    part.background_color = background_color;
                }
                //#endregion 
                this.partMaps.set(part_key, part);                
            }
        }
        this.status = SplashpageStatus.Success;
    }
}



// WEBPACK FOOTER //
// ./src/Apps/ticketing/stores/splashpage.ts